import i18n, { InitOptions } from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector, { DetectorOptions } from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export enum LanguageCodes {
  en = 'en',
  sv = 'sv',
  nl = 'nl',
  de = 'de',
  es = 'es',
}

export const supportedLanguages = Object.values(LanguageCodes);

const detectorOptions: DetectorOptions = {
  order: ['navigator'],
};

const initOptions: InitOptions = {
  supportedLngs: supportedLanguages,
  detection: detectorOptions,
  interpolation: {
    escapeValue: false,
  },
};

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init(initOptions);

export const getSpeechRecognitionLangCode = (langCode: string): string => {
  switch (langCode) {
    case LanguageCodes.en:
      return 'en-US';
    case LanguageCodes.sv:
      return 'sv-SE';
    case LanguageCodes.nl:
      return 'nl-NL';
    case LanguageCodes.de:
      return 'de-DE';
    case LanguageCodes.es:
      return 'es-ES';
    default:
      return 'en-US';
  }
};

export const getCountryName = (langCode: string): string => {
  switch (langCode) {
    case LanguageCodes.en:
      return 'United Kingdom';
    case LanguageCodes.sv:
      return 'Sweden';
    case LanguageCodes.nl:
      return 'Netherlands';
    case LanguageCodes.de:
      return 'Germany';
    case LanguageCodes.es:
      return 'Spain';
    default:
      return 'United Kingdom';
  }
};

export default i18n;
